import { FC, useState } from 'react';
import { IconButton, Menu, MenuItem, Stack } from '@mui/material';
import { ArrowBack, MoreVert, RotateLeft, Settings } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import './AssistantChatHeader.scss';

interface AssistantChatHeaderProps {
  showBackButton?: boolean;
  onBackPress?: () => void;
  onOpenSettings: () => void;
  onRefresh: () => void;
  className?: string;
  showMenu?: boolean;
}

const AssistantChatHeader: FC<AssistantChatHeaderProps> = ({
  showBackButton = false,
  onBackPress = () => {},
  onOpenSettings,
  onRefresh,
  className = '',
  showMenu = true,
}) => {
  const { t } = useTranslation();
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleOpenSettings = () => {
    handleCloseMenu();
    onOpenSettings();
  };

  const handleRefresh = () => {
    handleCloseMenu();
    onRefresh();
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      className={`assistant-chat-header ${className}`.trim()}
    >
      <Stack direction="row" gap={1}>
        {showBackButton && (
          <IconButton className="assistant-chat-header__icon-button" onClick={onBackPress}>
            <ArrowBack className="assistant-chat-header__icon-button__icon" />
          </IconButton>
        )}
      </Stack>

      {showMenu && (
        <>
          <IconButton className="assistant-chat-header__icon-button" onClick={handleOpenMenu}>
            <MoreVert className="assistant-chat-header__icon-button__icon" />
          </IconButton>
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleCloseMenu}
            PaperProps={{
              className: 'custom-paper-modal',
            }}
          >
            <MenuItem
              onClick={handleOpenSettings}
              className="assistant-chat-header__menu-item"
              sx={{ fontSize: '12px', minHeight: 'auto', py: 0.75 }}
            >
              <Settings sx={{ fontSize: 14, mr: 1 }} />
              {t('task.ai.header.settings')}
            </MenuItem>
            <MenuItem
              onClick={handleRefresh}
              className="assistant-chat-header__menu-item"
              sx={{ fontSize: '12px', minHeight: 'auto', py: 0.75 }}
            >
              <RotateLeft sx={{ fontSize: 14, mr: 1 }} />
              {t('task.ai.header.refresh')}
            </MenuItem>
          </Menu>
        </>
      )}
    </Stack>
  );
};

export default AssistantChatHeader;
